module.exports = __webpack_public_path__ + "img/ANTENNA 5 GREEN.dcf13eb.svg";